import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=c00ce68a&scoped=true"
import script from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=c00ce68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00ce68a",
  null
  
)

export default component.exports